// Native GET navigation keeps the URL, filter links and SEO metadata in sync.
export default function initNewsCatalogFilters(form) {
  const search = form.querySelector('[name="search"]');
  const date = form.querySelector('[name="date"]');
  const wrapper = form.querySelector('.js-article-list__input-block');
  let timeout;

  const submit = () => {
    clearTimeout(timeout);
    form.requestSubmit();
  };

  form.addEventListener('submit', () => clearTimeout(timeout));
  search.addEventListener('input', () => {
    clearTimeout(timeout);
    timeout = setTimeout(submit, 2000);
  });
  search.addEventListener('focus', () => wrapper.classList.add('article-list__input-block--focused'));
  search.addEventListener('blur', () => wrapper.classList.remove('article-list__input-block--focused'));
  date.addEventListener('blur', submit);
}
